import axiosApp from "../utils/axiosConfig";

const listUrl = `${process.env.REACT_APP_API_IP}/api/v1/notes`;

export const getAllNotes = async (token) => {
  return await axiosApp.get(listUrl, {
    headers: { Authorization: "Bearer " + token },
  });
};

export const createNote = async (token, newList) => {
  const res = await axiosApp.post(listUrl, newList, {
    headers: { Authorization: "Bearer " + token },
  });
  return res.data.data;
};

export const updateNote = async (token, listId, newList) => {
  try {
    await axiosApp.patch(listUrl + "/" + listId, newList, {
      headers: { Authorization: "Bearer " + token },
    });
    return null;
  } catch (error) {
    return error.response.data;
  }
};

export const deleteNote = async (token, listId) => {
  const response = await axiosApp.delete(listUrl + "/" + listId, {
    headers: { Authorization: "Bearer " + token },
  });
  if (response.status === 204) {
    return true;
  } else {
    return false;
  }
};
